import { Controller } from "@hotwired/stimulus"

// 프리셋 버튼으로 숫자 입력값을 채운다 (2026-07-24, 운영 설정).
// 운영자가 "2시간"처럼 흔한 값을 직접 타이핑하지 않고 한 번에 고르게 한다.
// 선택된 프리셋은 active 표시하고, 값이 프리셋과 다르면 아무 것도 강조하지 않는다.
export default class extends Controller {
  static targets = ["input", "option"]

  connect() {
    this.sync()
  }

  choose(event) {
    const value = event.currentTarget.dataset.presetValue
    this.inputTarget.value = value
    this.sync()
  }

  sync() {
    const current = String(this.inputTarget.value).trim()
    this.optionTargets.forEach((btn) => {
      const on = btn.dataset.presetValue === current
      btn.classList.toggle("btn-active", on)
      btn.classList.toggle("btn-primary", on)
      btn.setAttribute("aria-pressed", on ? "true" : "false")
    })
  }
}
